// extracted by mini-css-extract-plugin
export default {"circle":"styles-module--circle--3aB7d","container":"styles-module--container--3BkG0","blank":"styles-module--blank--1iZTO","opacity":"styles-module--opacity--szc1m"};